import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("th", null, _toDisplayString(_ctx.props.name), 1),
    _createElementVNode("td", {
      class: _normalizeClass(`text-${_ctx.props.class}`)
    }, _toDisplayString(_ctx.props.value), 3)
  ]))
}